import React from 'react';
import { Box, Button, Typography } from '@mui/material';
import { useChatbotSettingsContext } from '../../../utils/ContextProviders/ChatbotSettingsContextProvider';
import { VIEW_TYPES } from '../utils';

const ChatbotSettingsHeader = () => {
  const { view, settingsFormData, handlePublishUpdates } =
    useChatbotSettingsContext();

  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        py: 2
      }}
    >
      <Typography variant="h5" sx={{ fontWeight: 'bold' }}>
        Chatbot Settings
      </Typography>
      {view.view === VIEW_TYPES.COMMUNITY_CHATBOT_SETTINGS && (
        <Box sx={{ display: 'flex', gap: 1 }}>
          <Button variant="outlined">Cancel</Button>
          <Button
            variant="contained"
            onClick={() => handlePublishUpdates(settingsFormData)}
          >
            Publish Updates
          </Button>
        </Box>
      )}
    </Box>
  );
};

export default ChatbotSettingsHeader;
